import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaInfoCircle, FaRegCopyright } from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  const legalLinks = [
    { to: '/cookie-policy', label: t('footer.cookiePolicy') },
    { to: '/privacy-policy', label: t('footer.privacyPolicy') },
    { to: '/terms', label: t('footer.termsOfUse') },
  ];

  return (
    <footer className="mt-auto border-t border-white/[0.06] bg-gradient-to-r from-slate-900/95 via-indigo-950/95 to-slate-900/95 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <Link to="/" className="flex items-center gap-2 group">
              <GiMeditation className="text-2xl text-teal-400 transition-transform group-hover:rotate-[-8deg]" />
              <span className="text-xl font-extrabold tracking-tight">
                BetZen<span className="text-teal-400">.app</span>
              </span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed text-center md:text-left max-w-xs">
              {t('footer.description')}
            </p>
            <p className="text-xs text-gray-500 flex items-center gap-1">
              <FaRegCopyright className="text-gray-500" />
              BetZen.app {new Date().getFullYear()} &mdash;{' '}
              {t('footer.allRightsReserved')}
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-300 flex items-center gap-2">
              <FaShieldAlt className="text-teal-400 text-xs" />
              {t('footer.legalInformation')}
            </h4>
            <div className="flex flex-col gap-1.5">
              {legalLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors duration-200 flex items-center gap-2 group"
                >
                  <span className="w-1 h-1 rounded-full bg-teal-400/40 group-hover:bg-teal-400 transition-colors" />
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Disclaimer */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-300 flex items-center gap-2">
              <FaInfoCircle className="text-teal-400 text-xs" />
              {t('footer.disclaimer')}
            </h4>
            <p className="text-sm text-gray-400 leading-relaxed text-center md:text-left">
              {t('footer.disclaimerText')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
